import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";
import useFetchData from "../../../../repo/get";
import { MultiSelect } from 'primereact/multiselect'
import FichaDetails from "components/hooks/FichaDetails";


function CardNaRua() {
  const baseSelect = localStorage.getItem("baseSelected") || "";
  const cargoSelect = localStorage.getItem("cargo") || "";
  const { data: retiradoData } = useFetchData(`api/romaneios/getMinimalAll/retirado/${baseSelect}`);
  const { data: alocadoData } = useFetchData(`api/romaneios/getMinimalAll/alocado/${baseSelect}`);
  const [data, setData] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [motoristaOptions, setmotoristaOptions] = useState([]);
  const [selectedFicha, setSelectedFicha] = useState(null);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: "contains" },
    codigodeficha: { value: null, matchMode: "contains" },
    horaedia: { value: null, matchMode: "contains" },
    local: { value: [], matchMode: "in" }, 
    entregador: { value: null, matchMode: "contains" },
    motorista: { value: [], matchMode: "in" },
  });

  useEffect(() => {
    if (retiradoData || alocadoData) {
      const combinedData = [...(retiradoData || []), ...(alocadoData || [])];
      const formattedData = combinedData.map((ficha) => ({
        ...ficha,
        codigodeficha: ficha.codigoUid,
        horaedia: ficha.dataRetirado.replace("T", " ").split(".")[0],
        horaediaf: ficha.data.replace("T", " ").split(".")[0],

        empresa: ficha.empresa,
        entregador: ficha.entregador,
        motorista: ficha.motorista,
        local: ficha.cidade,
        status: ficha.status,
      }));

      const filteredData = formattedData.filter(
        (ficha) => ficha.status === "retirado" || ficha.status === "alocado"
      );
      const uniqueRegions = [
        ...new Set(filteredData.map(item => item.local))
      ];
      const uniqueMotorista = [
        ...new Set(filteredData.map(item => item.motorista))
      ];
      setRegionOptions(uniqueRegions);
      setmotoristaOptions(uniqueMotorista);
      if (cargoSelect === "ENTREGADOR"){
        
        setData(filteredData.filter(func => func.entregador === localStorage.getItem("nome")));
      } else { 
        setData(filteredData);
      };
    }
  }, [retiradoData, alocadoData]);

  const onRowSelect = (e) => {
    setSelectedFicha(e.data);
  };

  const closeDetails = () => {
    setSelectedFicha(null);
  };

  const header = (
    <div className="table-header">
      {cargoSelect !== "ENTREGADOR" && (
      <div className="flex justify-between items-center w-full">
        <div className="flex flex-col md:flex-row  justify-between space-x-4">
          {/* Filtro de Entregador */}
          <MultiSelect
            value={filters.motorista.value}
            options={motoristaOptions.map(motorista => ({ label: motorista, value: motorista }))}
            onChange={(e) => setFilters({ ...filters, motorista: { value: e.value, matchMode: 'in' } })}
            placeholder="Motorista"
            className="bg-lightBlue-200 p-input-icon-left md:w-14rem border border-black h-full font-bold"
            filter
            filterPlaceholder="Buscar motorista..."
            filterBy="label"
          />

          {/* Filtro de Local */}
          <MultiSelect
            value={filters.local.value}
            options={regionOptions.map(local => ({ label: local, value: local }))}
            onChange={(e) => setFilters({ ...filters, local: { value: e.value, matchMode: 'in' } })}
            placeholder="Local de destino"
            className="bg-lightBlue-200 p-input-icon-left md:w-14rem border border-black h-full font-bold"
            filter
            filterPlaceholder="Buscar local..."
            filterBy="label"
          />

        </div>

        {/* Botão de Limpar Filtros */}
        <Button
          onClick={() => setFilters({
            local: { value: null, matchMode: 'equals' },
            motorista: { value: null, matchMode: 'equals' }
          })}
          icon="pi pi-refresh"
          className="bg-red-500 text-white px-3 py-1 m-2 rounded-md shadow hover:bg-red-600 font-bold"
        >
        </Button>
      </div>
      )}
      <p><strong>&#8203;</strong></p>
      <div className="flex flex-col md:flex-row  justify-between items-center w-full">
        <span className="p-input-icon-left">
          <InputText
            type="search"
            onInput={(e) => setFilters({ ...filters, global: { value: e.target.value, matchMode: 'contains' } })}
            placeholder="Buscar..."
          />
        </span>
        <h4 className="p-input-icon-right text-2xl uppercase font-bold text-blueGray-700 ml-auto">
          {data.length} Sacas Em Trânsito
        </h4>
      </div>
    </div>
  );

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
      <Dialog
        header="Detalhes da Ficha"
        visible={selectedFicha !== null}
        style={{ width: '70%' }}
        onHide={closeDetails}
      >
        {selectedFicha ? <FichaDetails ficha={selectedFicha.codigoUid} /> : <p>Loading...</p>}
      </Dialog>

      <DataTable
        value={data}
        paginator
        stripedRows
        rows={25}
        rowsPerPageOptions={[5, 10, 25, 50, 99999]}
        tableStyle={{ minWidth: "50rem" }}
        selectionMode="single"
        onRowSelect={onRowSelect}
        filters={filters}
        globalFilterFields={['codigodeficha', 'horaedia', 'horaediaf' ,'local', 'motorista']}
        emptyMessage="Nenhum resultado encontrado."
        header={header}
      >
        <Column field="codigodeficha" header="Código de Ficha" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
        <Column field="horaedia" header="Data da retirada" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
        <Column field="horaediaf" header="Data da criação" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
        <Column field="local" header="Local" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
        <Column field="motorista" header="Motorista" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
      </DataTable>
    </div>
  );
}

export default CardNaRua;
